import { getBriefAPI } from "@/api/brief/briefList";

export default  {
    namespaced:true,
    state: () => ({
        briefList: [],
        language: {
            en: 'EN',
            ko: 'KR',
            ja: 'JP',
            zh: 'CN',
        } 
    }),
    mutations: {
        setBrief(state, briefData) {
            state.briefList = briefData;
        }
    },
    actions: {
        async getBrief({state, commit}, lang) {
            const selectLang = state.language[lang] || 'KR'
            const { data, error } = await getBriefAPI(selectLang);

            if (error) {
                console.log(error)
                throw error
            } else {
                const filteredResults = data.results
                .filter(list => list.date !== null && list.title !== "")
                .map(list => ({
                    ...list,
                    thum: list.thum || 'https://gpt-premium-charts.s3.ap-northeast-2.amazonaws.com/charts/month-chart-281fdd19-7977-40ee-b612-fc769ae07ff0.png'
                }));

                commit("setBrief", filteredResults);
            }
        },

    }
};